<template>
	<div @click.stop.prevent="handleClick">
		<div class="row">
			<div class="col-12 col-xs-12 col-sm-6">
				<h3 class="txt--xl mb-1 mb--1">{{q.title}}</h3>
				<p v-if="q.description != ''" v-html="q.description"></p>
			</div>
			<div class="col-12 col-xs-12 col-sm-6">
			<div class="list-group">				
				<div v-for="o in q.options" :key="o.id">
					<button	
						:id="q.id + '-' + o.id"			
						type="button"
						@click="optionSelected(q.id, o.id)"
						@keydown.enter="optionSelected(q.id, o.id)"
						class='list-group-item list-group-item-action d-flex justify-content-between align-items-center' :class="{'active' : o.selected}">
						{{o.text}}
					</button>
				</div>
			</div>
			</div>
		</div>
		<hr  class="mb-2 mb--2">
	</div>
</template>

<script>
	export default {
		name: "Question",
		props: {
			q: Object
		},		
		data() {
			return this.initialState();
		},
		methods: {
								
			handleClick(e) {
				if (e.target.matches("a")) {
					let url = e.target.href;
					let target = e.target.target == "_blank" ? "_blank" : "_self";
					let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
					var isnativeapp = document.getElementById("isnativeapp");
					if (isnativeapp === undefined || isnativeapp === null) 
					{
						window.open(url,target);  
					}
					else{
						if(target == "_blank") {
							let data = {title:'',nodeid: dataId, href:url, target: target};
							window.Native('dataCallback', data);
						} 
					}	
				}
			},

			initialState() {
				return {
					text: null,
					value: null
				}
			},

			reset() {
				Object.assign(this.$data, this.initialState());
				this.q.options.forEach(o => {
					o.selected = false;
				});
			},

			optionSelected(qid, oid) {
				this.$emit("click");
				this.$emit("keydown.enter");
				if (this.q.id === qid) {
					this.q.options.forEach(o => {
						if (o.id === oid) {
							if(o.selected)
							{
								o.selected = false;
								this.text = null;
								this.value = null;
							}
							else
							{
								o.selected = true;								
								this.text = o.text;
								this.value = o.value;
							}
						} else {
							o.selected = false;
						}
					});
				}
			}
		}
	};
</script>